<template>
  <v-dialog
    :value="true"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="slide-y-reverse-transition"
    max-width="800"
    scrollable
    persistent
  >
    <UserForm
      :disabled="savingUser"
      :errors="userValidationErrors"
      :user="editedUser"
      @clear:errors="clearUserValidationErrors"
      @cancel="$router.push({ name: 'users' })"
      @save="onSave"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import store from '../../store';
import UserForm from '../../components/UserForm';

export default {
  name: 'EditUser',

  components: { UserForm },

  computed: mapState('users', ['editedUser', 'userValidationErrors', 'savingUser']),

  beforeRouteEnter(to, from, next) {
    store
      .dispatch('users/editUser', to.params.id)
      .then(() => {
        next();
      })
      .catch(() => {
        next({ name: 'users' });
      });
  },

  methods: {
    ...mapActions('users', ['updateUser', 'clearUserValidationErrors']),

    async onSave(user) {
      this.updateUser(user).then(() => {
        this.$router.push({ name: 'users' });
      });
    },
  },
};
</script>
